function isFirestoreTimestamp(value: unknown): value is { toDate(): Date } {
  return (
    value !== null &&
    typeof value === 'object' &&
    typeof (value as any).toDate === 'function' &&
    typeof (value as any).seconds === 'number' &&
    typeof (value as any).nanoseconds === 'number'
  );
}

export function convertTimestampsToDates<T>(obj: T): T {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  for (const key in obj as object) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = (obj as any)[key];

      if (isFirestoreTimestamp(value)) {
        (obj as any)[key] = value.toDate();
      } else if (typeof value === 'object') {
        convertTimestampsToDates(value);
      }
    }
  }

  return obj;
}
